const e = {
  DEFAULT: { retries: 60, minTimeout: 2e3, factor: 1 },
  WAIT_WEB3: { retries: 30, minTimeout: 1e3, factor: 1 },
  WAIT_METAMASK: { retries: 30, minTimeout: 1e3, factor: 1 },
  WAIT_WALLET_CONNECT: { retries: 30, minTimeout: 1e3, factor: 1 },
  WAIT_OPERATION: { retries: 10, minTimeout: 1e3, factor: 1 },
  GRAPHQL: {
    DEFAULT: {
      delay: {
        initial: 300,
        max: 3e3,
        jitter: !1
      },
      attempts: {
        max: 3
      }
    },
    POLL_AFTER_TX_SUCCESS: {
      DEFAULT: {
        retries: 100,
        minTimeout: 3e3,
        factor: 1
      }
    }
  },
  CONTRACT: {
    DEFAULT: { retries: 3, minTimeout: 1e3, factor: 1 },
    SEND: { retries: 100, minTimeout: 2e3, factor: 1 }
  },
  WAIT_VERIFY_GNOSIS: {
    forever: !0,
    factor: 1,
    minTimeout: 1e3,
    // 1 second
    maxTimeout: 2e3
    // 2 second
  }
};
export {
  e as RETRY
};
//# sourceMappingURL=retry.js.map
